declare var jQuery: any;

export function openModal(modalId) {
  jQuery(modalId).modal('show');
};

export function closeModal(modalId) {
  jQuery('.modal-backdrop').remove();
  jQuery(modalId).modal('hide');
};

export function closeModalWithoutRemovingBackdrop(modalId) {
  jQuery(modalId).modal('hide');
  jQuery(modalId).on('hidden.bs.modal', function (e) {
    jQuery(document.body).addClass('modal-open');
  })
};



// WEBPACK FOOTER //
// /codebuild/output/src4156872633/src/src/app/shared/modal-functions.ts